import React, {
  useState,
  useEffect,
  Fragment,
  useMemo,
  useCallback,
} from 'react';
import ReactTable from 'react-table';
import {
  Row,
  Card,
  Button,
  NavItem,
  Nav,
  TabContent,
  TabPane,
  CardBody,
  Input,
} from 'reactstrap';
import Select from 'react-select';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Groups,
  gAPI_CheckUser_Groups,
  gAPI_Site_Settings,
  gAPI_User_SignIn_Logs_Group,
  gAPI_Internal_Property_List,
} from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CreateGroupsForm from './components/forms/CreateGroupsForm';
import UpdateGroupsForm from './components/forms/UpdateGroupsForm';
import DetailButton from '../groups/components/forms/DetailButton';
import classnames from 'classnames';
import Property from './properties';
import SignInLogs from './signinlogs';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { reactSelectOptionDiffrentPro } from '../../../../../helpers/Utils';

import GroupTablePagination from '../../../../../components/GroupTablePaginate';

const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
    top:auto !important;
    bottom: 0 !important;
  }
  .active{
    background-color:transparent;
  }`;
function Index({ propertyId, history, serviceProvider }) {
  const [groupList, setGroupsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [serviceProviderList, setServiceProviderList] = useState([]);
  const [filteredData, setFilterData] = useState([]);
  const [activeTab, setActiveTab] = useState('Groups');
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [isFiltering, setIsFiltering] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filterCountry, setFilterCountry] = useState('');
  const [filterGroupName, setFilterGroupName] = useState('');
  const [filterChainId, setFilterChainId] = useState('');
  const statusList = [
    { label: 'Approved', value: 'Approved' },
    { label: 'Archived', value: 'Archived' },
    { label: 'Inactive', value: 'Inactive' },
    { label: 'Pending Approval', value: 'PendingApproval' },
  ];
  const [allPropertyList, setAllPropertyList] = useState([]);
  const loadServiceProviderList = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Site_Settings}`,
    }).then((res) => {
      if (res.data.length > 0) {
        setServiceProviderList(res.data);
      }
    });
  };
  const LoadGroups = useCallback(() => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_CheckUser_Groups}/${getUserID()}`,
    })
      .then((res) => {
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_Groups}/${getUserID()}`,
        })
          .then((res) => {
            setGroupsList(res.data);
            setLoading(false);
          })
          .catch((err) => console.log('err', err));
      })
      .catch((err) => history.push('/app/error'));
  }, [history]);

  useEffect(() => {
    LoadGroups();
    loadServiceProviderList();
  }, [LoadGroups, propertyId]);
  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Internal_Property_List}?group_id=${getGroupID()}`,
    }).then((res) => {
      setAllPropertyList(res.data || []);
    });
  }, []);
  const handleStatusChange = (selected) => {
    setSelectedStatus(selected);
  };

  const handleFilterSearch = () => {
    const statusValues = selectedStatus.map((s) => s.value.toLowerCase());

    const filtered = groupList.filter((group) => {
      const matchStatus =
        statusValues.length === 0 ||
        statusValues.includes(group.status.toLowerCase());
      const matchCountry =
        !filterCountry ||
        group.country?.toLowerCase().includes(filterCountry.toLowerCase());
      const matchGroupName =
        !filterGroupName ||
        group.name?.toLowerCase().includes(filterGroupName.toLowerCase());
      const matchChainId =
        !filterChainId ||
        group.chainId?.toLowerCase().includes(filterChainId.toLowerCase());

      return matchStatus && matchCountry && matchGroupName && matchChainId;
    });

    setFilterData(filtered);
    setIsFiltering(false);
  };

  const columns = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
        Cell: (props) => (
          <div className="d-flex flex-wrap pr-3">
            <p>{props.original.name}</p>
            <DetailButton id={props.original.groupId} LoadGroups={LoadGroups} />
          </div>
        ),
      },
      {
        Header: 'Group ID',
        accessor: 'groupId',
        Cell: (props) => <p className="">{props.original.groupId}</p>,
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: (props) => (
          <p className="pl-3">
            {props.original.status === 'PendingApproval'
              ? 'Pending Approval'
              : props.original.status}
          </p>
        ),
      },
      {
        Header: 'Country',
        accessor: 'country',
        Cell: (props) => <p className="pl-4">{props.original.country}</p>,
      },
      {
        Header: 'Edit',
        accessor: 'edit',
        Cell: (props) => (
          <UpdateGroupsForm
            serviceProviders={serviceProviderList}
            id={props.original.groupId}
          />
        ),
      },
      {
        Header: 'Actions',
        accessor: 'actions',
        Cell: (props) => (
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => {
              setSelectedGroupId(props.original);
              setActiveTab('Properties');
            }}
          >
            View Properties
          </Button>
        ),
      },
    ],
    [LoadGroups, serviceProviderList]
  );

  if (loading) {
    return (
      <Card className="d-flex flex-row mb-3">
        <CardBody>
          <h4 style={{ textAlign: 'center' }}>Loading...</h4>
        </CardBody>
      </Card>
    );
  }

  return (
    <Fragment>
      <Row>
        <Colxx xxs={12}>
          <Nav tabs className="card-header-tabs separator-tabs mb-3 ml-2 mr-0">
            <style>{style_css}</style>
            <NavItem
              className="text-center"
              style={{ width: 'auto', background: '' }}
            >
              <div
                className={classnames('nav-link', {
                  active: activeTab === 'Groups',
                })}
                onClick={() => setActiveTab('Groups')}
                style={{ cursor: 'pointer' }}
              >
                <span
                  style={{
                    color:
                      activeTab === 'Groups'
                        ? 'var(--theme-color-1)'
                        : '#8f8f8f',
                  }}
                >
                  Groups
                </span>
              </div>

              {/* <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                className={classnames('nav-link', { active: activeTab === 'Groups' })}

                onClick={() => {
                  setActiveTab('Groups');
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${activeTab === 'Groups'
                      ? 'var(--theme-color-1)'
                      : '#8f8f8f'
                      }`,
                  }}
                >
                  Groups
                </span>
              </NavLink> */}
            </NavItem>
            <NavItem
              className="text-center"
              style={{ width: 'auto', background: '' }}
            >
              <div
                className={classnames('nav-link', {
                  active: activeTab === 'Properties',
                })}
                onClick={() => setActiveTab('Properties')}
                style={{ cursor: 'pointer' }}
              >
                <span
                  style={{
                    color:
                      activeTab === 'Properties'
                        ? 'var(--theme-color-1)'
                        : '#8f8f8f',
                  }}
                >
                  Properties
                </span>
              </div>
              {/* <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                className={classnames('nav-link', { active: activeTab === 'Properties' })}

                onClick={() => {
                  setActiveTab('Properties');
                }}
                to="#"
              >
                {' '}
                <span
                  style={{
                    color: `${activeTab === 'Properties'
                      ? 'var(--theme-color-1)'
                      : '#8f8f8f'
                      }`,
                  }}
                >
                  Properties
                </span>
              </NavLink> */}
            </NavItem>
            <NavItem
              className="text-center"
              style={{ width: 'auto', background: '' }}
            >
              <div
                className={classnames('nav-link', {
                  active: activeTab === 'Sign-in Logs',
                })}
                onClick={() => setActiveTab('Sign-in Logs')}
                style={{ cursor: 'pointer' }}
              >
                <span
                  style={{
                    color:
                      activeTab === 'Sign-in Logs'
                        ? 'var(--theme-color-1)'
                        : '#8f8f8f',
                  }}
                >
                  Sign-in Logs
                </span>
              </div>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab} className="">
            <TabPane tabId="Groups" className="chat-app-tab-pane">
              <Row className="mb-3 ml-2">
                <Button
                  size="xs"
                  color="primary"
                  onClick={() => setIsFiltering(!isFiltering)}
                >
                  <div className="d-flex">
                    <FontAwesomeIcon icon={faFilter} className="fa mr-1 mt-1" />
                    <IntlMessages id="menu.show-filter" />
                    <div className="ml-1" style={{ marginTop: '2px' }}>
                      {isFiltering ? (
                        <i className="simple-icon-arrow-up p-1"></i>
                      ) : (
                        <i className="simple-icon-arrow-down p-1"></i>
                      )}
                    </div>
                  </div>
                </Button>

                <CreateGroupsForm
                  serviceProviders={serviceProviderList}
                  service={serviceProvider}
                />
                {/* <Colxx xxs="4">
                  <CustomInput
                    type="checkbox"
                    checked={showApprovalGroups}
                    onClick={() => {
                      setShowApprovalGroups(!showApprovalGroups);
                    }}
                    label="Show Groups Pending for Approval"
                  ></CustomInput>
                </Colxx> */}
              </Row>
              {isFiltering && (
                <Card
                  className="filter-width mt-2"
                  style={{
                    zIndex: '1',
                    marginLeft: '0rem',
                    marginBottom: '2rem',
                    boxShadow:
                      '0 1px 20px 20px rgb(0 0 0 / 4%), 0 1px 6px rgb(0 0 0 / 4%)',
                  }}
                >
                  <CardBody>
                    <Colxx md="12">
                      <Row>
                        <Colxx xxs="12" md="12" className="mb-2">
                          <Input
                            className="input_sty"
                            type="text"
                            placeholder="Filter by Group Name"
                            value={filterGroupName}
                            onChange={(e) => setFilterGroupName(e.target.value)}
                          />
                        </Colxx>
                        <Colxx xxs="12" md="12" className="mb-2">
                          <Input
                            className="input_sty"
                            type="text"
                            placeholder="Filter by Country"
                            value={filterCountry}
                            onChange={(e) => setFilterCountry(e.target.value)}
                          />
                        </Colxx>
                        <Colxx xxs="12" md="12" className="mb-2">
                          <Select
                            isMulti
                            className="react-select"
                            classNamePrefix="react-select"
                            name="status"
                            placeholder="Filter by Status"
                            onChange={handleStatusChange}
                            options={
                              statusList
                                ? reactSelectOptionDiffrentPro(
                                  statusList,
                                  true,
                                  'value',
                                  'label',
                                  'Select Status'
                                )
                                : []
                            }
                            value={selectedStatus}
                          />
                        </Colxx>
                        {(serviceProvider === '2' || serviceProvider === '5') &&
                          <Colxx xxs="12" md="12" className="mb-2">
                            <Input
                              className="input_sty"
                              type="text"
                              placeholder="Filter by Chain Id"
                              value={filterChainId}
                              onChange={(e) => setFilterChainId(e.target.value)}
                            />
                          </Colxx>
                        }
                        <Colxx xxs="12" md="12">
                          <Button
                            size="xs"
                            color="primary"
                            className="mb-2 mt-2"
                            onClick={handleFilterSearch}
                          >
                            Search
                          </Button>
                          <Button
                            size="xs"
                            color="secondary"
                            className="mb-2 ml-2 mt-2"
                            onClick={() => {
                              setIsFiltering(false);
                              setSelectedStatus([]);
                              setFilterGroupName('');
                              setFilterCountry('');
                              setFilterChainId('');
                              setFilterData([]);
                            }}
                          >
                            Cancel
                          </Button>
                        </Colxx>
                      </Row>
                    </Colxx>
                  </CardBody>
                </Card>
              )}
              <Separator className="mb-5 " />
              <Row>
                <Colxx xxs={12}>
                  <Card>
                    <CardBody>
                      {/* {(filteredData.length > 0 ? filteredData : groupList).map((group, index) => {
                        console.log('group', group);
                        return (

                          <Colxx xxs="12" key={index}>
                            */}
                      <ReactTable
                        data={
                          filteredData.length > 0 ? filteredData : groupList
                        }
                        columns={columns}
                        defaultPageSize={25}
                        className="-striped -highlight"
                        PaginationComponent={GroupTablePagination}
                        filterable={false}
                        showPageJump={true}
                        showPageSizeOptions={true}
                      />

                      {/* {showApprovalGroups === false &&
                              group.status !== 'PendingApproval' ? (
                              <Card className="d-flex flex-row mb-3">
                                <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                                  <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                                    <p className="mb-1  text-small w-50 w-sm-100">
                                      <b>{group.name}</b>
                                    </p>
                                    <p className="mb-1  text-small w-50 w-sm-100">
                                      {group.groupId}
                                    </p>
                                    <p className="mb-1  text-small w-25 w-sm-100">
                                      {group.status}
                                    </p>
                                    <p className="mb-1  text-small w-15 w-sm-100">
                                      {group.country}
                                    </p>

                                    <div className="mb-1 w-15 w-sm-100">
                                      <UpdateGroupsForm serviceProviders={serviceProviderList} id={group.groupId} />
                                    </div>
                                    <div className="mb-1 w-20 w-sm-100">
                                      <Button
                                        color="primary"
                                        size="sm"
                                        outline
                                        onClick={() => ''}
                                      >
                                        View Group
                                      </Button>

                                    </div>
                                    <div className="mb-1 w-20 w-sm-100">
                                      <Button
                                        color="primary"
                                        size="sm"
                                        outline
                                        onClick={() => {
                                          setSelectedGroupId(group);
                                          setActiveTab('Properties');
                                        }}
                                      >
                                        View Properties
                                      </Button>

                                    </div>

                                  </div>
                                </div>
                              </Card>
                            ) : null} */}
                    </CardBody>
                  </Card>
                </Colxx>
              </Row>
            </TabPane>
          </TabContent>
          <TabContent activeTab={activeTab} className="">
            <TabPane tabId="Properties" className="chat-app-tab-pane">
              <Property
                activeGroup={selectedGroupId}
                service={serviceProvider}
              />
            </TabPane>
          </TabContent>
          <TabContent activeTab={activeTab} className="">
            <TabPane tabId="Sign-in Logs" className="chat-app-tab-pane">
              <SignInLogs propertyList={allPropertyList} />
            </TabPane>
          </TabContent>
        </Colxx>
      </Row>
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, serviceProvider } = settings;
  return {
    propertyId,
    serviceProvider,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
